<template>
  <div class="jps-image-selection-viewer">
    <ClientOnly>
      <UiIiifViewer v-if="viewerInfo" :image="viewerInfo">
        <template #info="">
          <UiRightsTag
            :rights="image.contentsRightsType"
            :rights-description="image.contentsRights"
          />
          <a
            class="jps-curation-modal-rights-info"
            v-if="image.source"
            :href="image.sourceUrl"
          >
            {{ ls(image.source) }}
            <BaseIcon name="mdi/open-in-new" />
          </a>
        </template>
      </UiIiifViewer>
    </ClientOnly>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()
const { compImageSelection, toViewerInfo } = useImageSelection()

interface Props {
  image: ImageSelection
}
const props = withDefaults(defineProps<Props>(), {})

const viewerInfo = computed(() => {
  return toViewerInfo(compImageSelection(props.image))
})
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-image-selection-viewer {
  position: relative;
  .jps-curation-modal-rights {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    > * {
      margin-right: 0.5rem;
    }
    .jps-curation-modal-label {
      margin-right: 0.5rem;
      line-height: 100%;
      @include is-mobile {
        display: inline-block;
      }
    }
    @include is-mobile {
      flex-direction: column;
      align-items: flex-start;
    }
    .jps-curation-modal-rights-type.is-dark {
      border: none;
    }
    .jps-curation-modal-rights-info {
      background: none;
    }
  }
}
</style>
